export default __webpack_public_path__ + "assets/iran-flag.png";